// extracted by mini-css-extract-plugin
export default {"lockedItemsList":"LockedItemsModal_lockedItemsList__yk7WQ","lockedItem":"LockedItemsModal_lockedItem__Ynz6p"};